/**
 * Created by Administrator on 2017-11-27.
 */
export function saveLocalStorage(data, dataName) {
  if (JSON.stringify(data) === '{}' || JSON.stringify(data) === '[]') {
    return
  }
  localStorage.setItem(dataName, JSON.stringify(data))
}

export function getLocalStorage(dataName) {
  return JSON.parse(localStorage.getItem(dataName))
}

export function clearLocalStorage(dataName) {
  localStorage.removeItem(dataName)
}



// WEBPACK FOOTER //
// ./src/common/js/localStorage.js